"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayDocRetailLocationHandler = void 0;
const React = require("react");
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../../hooks/useRequiredContext");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const CustomerPaymentMethodContext_1 = require("../../contexts/CustomerPaymentMethodContext");
const PayDockContext_1 = require("../../../../../contexts/PayDockContext");
const useClient_1 = require("../../../../../hooks/useClient");
const stringSanitizer_1 = require("../../../../../helpers/stringSanitizer");
/**
 * Provide the payment details for the paydoc service, based on the chosen retail location.
 */
const PayDocRetailLocationHandler = ({ children }) => {
    const client = (0, useClient_1.useClient)();
    const { retailLocation } = (0, useRequiredContext_1.useRequiredContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { paymentMethod } = (0, useRequiredContext_1.useRequiredContext)(CustomerPaymentMethodContext_1.CustomerPaymentMethodContext);
    const retailCustomer = (0, react_1.useMemo)(() => client.auth.session && client.auth.session.retailCustomer, [client.auth.session]);
    const value = (0, react_1.useMemo)(() => ({
        // gateway id priority:
        // from retail location
        // from retail customer default payment method
        gatewayId: retailLocation
            ? retailLocation.paymentGatewayId
            : paymentMethod
                ? paymentMethod.gatewayId
                : null,
        prefillData: retailCustomer
            ? {
                // BR-844 Paydock doesn't allow "-" or apostrophes for card name
                nameOnCard: (0, stringSanitizer_1.removeDashes)((0, stringSanitizer_1.removeApostrophes)(retailCustomer.name)),
                email: retailCustomer.email
            }
            : {}
    }), [retailCustomer, retailLocation, paymentMethod]);
    return (React.createElement(PayDockContext_1.PayDockContext.Provider, { value: value }, children));
};
exports.PayDocRetailLocationHandler = PayDocRetailLocationHandler;
//# sourceMappingURL=index.js.map